export const explore = [
    {
        label: 'Bull Shark Title',
        imageUrl: '/images/bullshark-3 1.png',
        videoUrl: '/videos/bullshark.mp4',
        icon: {
            active: "/images/bullshark_active.svg",
            inactive: "/images/ic_bullshark_inactive.svg",
        }
    },
    {
        label: 'Ocean Diving Title',
        imageUrl: '/images/image 110.png',
        videoUrl: '/videos/oceandive.mp4',
        icon: {
            active: "/images/ocean_active.svg",
            inactive: "/images/ic_ocean_inactive.svg"
        }
    },
    {
        label: 'Cenote Diving Title',
        videoUrl: '/videos/cocodrilo.mp4',
        imageUrl: '/images/image 89.png',
        icon: {
            active: "/images/cave_active.svg",
            inactive: "/images/ic_cave_inactive.svg"
        }
    }
];

export const courses = [
    {
        title: "Open Water Diver Title",
        imageURL: "/images/openWater.png",
        path: "/courses/open_water"
    },
    {
        title: "Advanced Open Water Diver Title",
        imageURL: "/images/advanced.png",
        path: "/courses/advanced_ow"
    },
    {
        title: "Rescue Diver Title",
        imageURL: "/images/rescue.png",
        path: "/courses/rescue_diver"
    },
    {
        title: "Dive Master Title",
        imageURL: "/images/divemaster.png",
        path: "/courses/divemaster"
    },
    {
        title: "Technical Scuba Diving Title",
        imageURL: "/images/technical.png",
        path: "/courses/technical"
    },
    {
        title: "Full Cave Scuba Diving Title",
        imageURL: "/images/fullcave.png",
        path: "/courses/full_cave"
    }
]

export const tours = [
    {
        title: "Cave Diving Title",
        text: "Cave Diving Text",
        image: "/images/cenoteCave.jpeg",
        path: "/cave_diving"
    },
    {
        title: "Whale Shark Title",
        text: "Whale Shark Text",
        image: "/images/whale.jpeg",
        path: "/whale_shark"
    },
    {
        title: "Bull Shark Title",
        text: "Bull Shark Text",
        image: "/images/bullshark-3 1.png",
        path: "/bullshark",
        price: "$150"
    },
    {
        title: "Coral Reef Title",
        text: "Coral Reef Text",
        image: "/images/coralReef.jpeg",
        path: "/coral_diving"
    },
    {
        title: "Cenote Snorkeling Title",
        text: "Cenote Snorkeling Text",
        image: "/images/cenoteSnorkeling.png",
        path: "/cenote_snorkeling"
    },
    {
        title: "Deep Dive Title",
        text: "Deep Dive Text",
        image: "/images/deepDive.png",
        path: "/deep_dive"
    },
    {
        title: "Cavern Diving Title",
        text: "Cavern Diving Text",
        image: "/images/cavern.png",
        path: "/cavern_diving"
    },
    {
        title: "Discover Scuba Diving Title",
        text: "Discover Scuba Diving Text",
        image: "/images/discoverScuba.png",
        path: "/discover_scuba"
    }
];


export const menuItems = {
    divingTours: {
        label: "Diving Tours",
        items: [
            { label: "Bull Shark Title", path: "/bullshark" },
            { label: "Coral Reef Title", path: "/coral_diving" },
            { label: "Cavern Diving Title", path: "/cavern_diving" },
            { label: "Cave Diving Title", path: "/cave_diving" },
            { label: "Whale Shark Title", path: "/whale_shark" },
            { label: "Cenote Snorkeling Title", path: "/cenote_snorkeling" },
            { label: "Deep Dive Title", path: "/deep_dive" },
            { label: "Discover Scuba Diving Title", path: "/discover_scuba" },
        ]
    },
    courses: {
        label: "Courses Title",
        items: [
            { label: "Discover Scuba Diving Title", path: "/discover_scuba" },
            { label: "Open Water Diver Title", path: "/courses/open_water" },
            { label: "Advanced Open Water Diver Title", path: "/courses/advanced_ow" },
            { label: "Rescue Diver Title", path: "/courses/rescue_diver" },
            { label: "EFR Title" },
            { label: "Dive Master Title", path: "/courses/divemaster" },
            { label: "T.D.I. Courses Title" },
            { label: "Technical Scuba Diving Title", path: "/courses/technical" },
        ]
    },
    Cart: {
        label: "Cart Title",

    },
    language: {
        items: [{ label: "EN" }, { label: "ES" }]
    }
}